import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from 'styled-components';
import { themeOptions, StyledToastContainer } from 'library/styles';
import RootRouter from './root-router';
import configureStore, { history } from './store';
import { contextClass } from './library/constants/context-class';
import 'react-toastify/dist/ReactToastify.minimal.css';

const store = configureStore();

const domContainer = document.querySelector('#root');
const root = ReactDOM.createRoot(domContainer);

const AppRoot = () => {
  return (
    <>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ThemeProvider theme={themeOptions}>
            <StyledToastContainer
              toastClassName={({ type }) => contextClass[type]}
              icon={false}
              closeButton
            />
            <RootRouter />
          </ThemeProvider>
        </ConnectedRouter>
      </Provider>
    </>
  );
};

root.render(React.createElement(AppRoot));
